var module = angular.module('octopusApp.tenants', []);

module.config(function($stateProvider, stateHelperProvider, tenantStateProvider, tenantVariablesStateProvider) {
    $stateProvider.state('app.tenants', {
        url: '/tenants?name&tags',
        template: stateHelperProvider.withBreadcrumb('Tenants', '#/tenants'),
        layout: {
            tab: 'tenants',
            title: 'Tenants'
        },
        defaultSubRoute: 'app.tenants.list'
    });

    $stateProvider.state('app.tenants.list', {
        url: '',
        templateUrl: 'areas/tenants/views/index.html',
        controller: 'TenantIndexController',
        controllerAs: 'vm',
        bindToController: true
    });

    $stateProvider.state('app.tenants.new', {
        url: '/new',
        templateUrl: 'areas/tenants/views/create.html',
        controller: 'TenantSettingsController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            title: 'Create Tenant'
        }
    });

    $stateProvider.state('app.tenants.edit', {
        url: '/:tenantId',
        templateUrl: 'areas/tenants/views/tenant_layout.html',
        controller: 'TenantLayoutController',
        controllerAs: 'vm',
        bindToController: true,
        resolve: {
            tenantState: tenantStateProvider.$get
        },
        defaultSubRoute: 'app.tenants.edit.overview'
    });

    $stateProvider.state('app.tenants.edit.overview', {
        url: '/overview',
        templateUrl: 'areas/tenants/views/overview.html',
        controller: 'TenantOverviewController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            tenantTab: 'overview',
            title: 'Tenant Overview'
        }
    });

    $stateProvider.state('app.tenants.edit.settings', {
        url: '/settings',
        templateUrl: 'areas/tenants/views/settings.html',
        controller: 'TenantSettingsController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            tenantTab: 'settings',
            title: 'Tenant Settings'
        }
    });

    $stateProvider.state('app.tenants.edit.logo', {
        url: '/logo',
        templateUrl: 'areas/tenants/views/change_logo.html',
        controller: 'TenantLogoController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            title: 'Tenant Logo',
            tenantTab: 'settings'
        }
    });

    $stateProvider.state('app.tenants.edit.variables', {
        url: '/variables',
        templateUrl: 'areas/tenants/variables/tenant_variables_tab.html',
        controller: 'TenantVariablesLayoutController',
        controllerAs: 'vm',
        bindToController: true,
        resolve: {
            tabState: tenantVariablesStateProvider.$get
        },
        layout: {
            title: 'Tenant Variables',
            tenantTab: 'variables'
        },
        defaultSubRoute: 'app.tenants.edit.variables.library'
    });


    $stateProvider.state('app.tenants.edit.variables.library', {
        url: '/library',
        templateUrl: 'areas/tenants/variables/tenant_variables_library.html',
        controller: 'TenantVariablesLibraryController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            variableTab: 'library'
        }
    });

    $stateProvider.state('app.tenants.edit.variables.projects', {
        url: '/projects',
        templateUrl: 'areas/tenants/variables/tenant_variables_projects.html',
        controller: 'TenantVariablesProjectsController',
        controllerAs: 'vm',
        bindToController: true,
        layout: {
            variableTab: 'projects'
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/tenants_module.js
// module id = 6932439187420001
// module chunks = 1